import { Link, useNavigate } from "react-router-dom";

interface BackToAuthorisationVersionsProps {
  profileNo: string;
}
const BackToAuthorisationVersions = ({
  profileNo,
}: BackToAuthorisationVersionsProps) => {
  const navigate = useNavigate();

  return (
    <span className="flex-fill w-100" style={{ display: "flex" }}>
      <a style={{ marginBottom: "10px" }} onClick={() => navigate(-1)}>
        &lt; Back to Authorisation Versions
      </a>
    </span>
  );
};

export default BackToAuthorisationVersions;
